<script lang="ts">
    import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
    import IconComponent from "@/components/atoms/Icon.vue";
    import { StepperState } from "@/components/atoms/stepper/stepper-state.interface";
    import { AccessibilityHandler, IconName, PerformanceQASelectors } from "webshop-modules";
    import { StepperAction } from "@/components/atoms/stepper/stepperAction.enum";

    @Component({
    components: { IconComponent }
})
export default class StepperComponent extends Vue {

    @Prop()
    public state!: StepperState;

    @Prop({ default: true })
    public showAmount!: boolean;

    public IconName = IconName;
    public readonly PerformanceQASelectors: typeof PerformanceQASelectors = PerformanceQASelectors;
    public readonly StepperAction: typeof StepperAction = StepperAction;

    @Emit()
    public stateChange(state: StepperState): StepperState {
        return state;
    }

    public decrease(): StepperState {
        const state: StepperState = JSON.parse(JSON.stringify(this.state)) as StepperState;

        if (this.state.canDecrease) {
            state.amount = state.amount - state.step;
            state.lastAction = StepperAction.DECREASE;
        } else {
            state.lastAction = StepperAction.NONE;
        }

        return state;
    }

    public increase(): StepperState {
        const state: StepperState = JSON.parse(JSON.stringify(this.state)) as StepperState;

        if (this.state.canIncrease) {
            state.amount = state.amount + state.step;
            state.lastAction = StepperAction.INCREASE;
        } else {
            state.lastAction = StepperAction.NONE;
        }

        return state;
    }

    public handleStateChangeEmit(action: StepperAction) {
        let state: StepperState | null = null;

        if (action === StepperAction.INCREASE) {
            state = this.increase();
        }

        if (action === StepperAction.DECREASE) {
            state = this.decrease();
        }

        if (!state || state.lastAction === StepperAction.NONE) {
            return;
        }

        this.stateChange(state);
    }

    public handleKeypress(event: KeyboardEvent, action: StepperAction) {
        AccessibilityHandler.handleActionWithCallback(event, () => {
            this.handleStateChangeEmit(action);
        });
    }

}
</script>

<template>
  <div class="a-Stepper">
    <div :data-qa="'stepper-decrease'"
         class="a-Stepper__control"
         v-bind:class="{ 'inactive': !state.canDecrease }"
         v-on:click="handleStateChangeEmit(StepperAction.DECREASE)"
         @keydown="handleKeypress($event, StepperAction.DECREASE)"
         tabindex="0">
      <div class="a-Stepper__iconContainer">
        <IconComponent :icon-id="IconName.Minus"/>
      </div>
    </div>

      <div class="a-Stepper__amount"
           v-show="showAmount"
           :data-qa="PerformanceQASelectors.STEPPER_AMOUNT">
          {{ state.amount }}
      </div>

    <div :data-qa="'stepper-increase'"
         class="a-Stepper__control"
         v-bind:class="{ 'inactive': !state.canIncrease }"
         v-on:click="handleStateChangeEmit(StepperAction.INCREASE)"
         @keydown="handleKeypress($event, StepperAction.INCREASE)"
         tabindex="0">
      <div class="a-Stepper__iconContainer">
        <IconComponent :icon-id="IconName.Plus"/>
      </div>
    </div>
  </div>
</template>
